import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import TextareaAutosize from 'react-autosize-textarea';
import './StatusChangeForm.scss';

const staticText = (modelName) => `You're about to make a change that affects a live ${modelName} and its status, outside of the normal workflow. Please make sure to confirm all of the info is correct.`;

function StatusChangeForm({
  title,
  modelName,
  modelOptions,
  modalStatusOptions,
  modelSelected,
  modelStatus,
  reason,
  handleInputChange,
  submitButtonDisabled,
  handleSubmit,
  error,
}) {
  return (
    <div className="status-change-container">
      <h1 className="title">{title}</h1>
      <h4 className="static-text">{staticText(modelName)}</h4>
      <div className="select-input">
        <label htmlFor="modelSelected">{`Select ${modelName}`}</label>
        <Select
          className="basic-single"
          classNamePrefix="select"
          defaultValue={modelSelected}
          value={modelSelected}
          isClearable
          isSearchable
          inputId="modelSelected"
          name="modelSelected"
          options={modelOptions}
          onChange={(e) => handleInputChange('modelSelected', e !== null ? e : '')}
        />
      </div>
      <div className="select-input">
        <label htmlFor="modleStatus">Select new status</label>
        <Select
          className="basic-single"
          classNamePrefix="select"
          defaultValue={modelStatus}
          value={modelStatus}
          isClearable
          isSearchable
          inputId="modelStatus"
          name="modelStatus"
          options={modalStatusOptions}
          onChange={(e) => handleInputChange('modelStatus', e !== null ? e : '')}
        />
      </div>
      <div className="textarea-field">
        <label htmlFor="reason">Change Reason</label>
        <TextareaAutosize
          value={reason}
          rows={3}
          id="reason"
          name="reason"
          placeholder="Enter change reason"
          onChange={(e) => handleInputChange('reason', e.currentTarget.value)}
        />
      </div>
      <div className="error">{error && error}</div>
      <div className="submit-button">
        <button
          type="button"
          className={submitButtonDisabled ? 'disabled' : 'active'}
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

StatusChangeForm.propTypes = {
  title: PropTypes.string.isRequired,
  modelName: PropTypes.string.isRequired,
  modelOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  modalStatusOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  modelSelected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]),
  modelStatus: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]),
  reason: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitButtonDisabled: PropTypes.bool,
  error: PropTypes.string,
};

StatusChangeForm.defaultProps = {
  submitButtonDisabled: false,
  reason: '',
  error: '',
  modelStatus: '',
  modelSelected: '',
};

export default StatusChangeForm;
